import React from 'react';
import LoadingSkeleton from '../Shared/LoadingSkeleton'; // Import Skeleton

// Added isLoading and error props
const BotDeploymentHistory = ({ history, isLoading, error }) => {
    if (isLoading) {
        return (
            <div className="mb-8 transform-gpu hover:scale-[1.01] transition-medium">
                <h3 className="font-bold text-lg mb-5 flex items-center group">
                    {/* ... header ... */}
                     <div className="w-10 h-10 rounded-lg bg-accent-blue/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium"> <i className="fas fa-history text-accent-blue"></i> </div>
                     Bot Deployment History
                     <i className="fas fa-spinner fa-spin text-xs ml-2 text-gray-400"></i>
                </h3>
                <div className="bg-dark-600 rounded-2xl p-6 hover:shadow-md transition-medium border border-dark-400 hover:border-accent-blue/30">
                    <LoadingSkeleton count={5} />
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="mb-8 transform-gpu hover:scale-[1.01] transition-medium">
                <h3 className="font-bold text-lg mb-5 flex items-center group">
                     {/* ... header ... */}
                      <div className="w-10 h-10 rounded-lg bg-accent-blue/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium"> <i className="fas fa-history text-accent-blue"></i> </div>
                     Bot Deployment History
                </h3>
                <div className="bg-dark-600 rounded-2xl p-6 text-center text-accent-red border border-accent-red/30">
                    <i className="fas fa-exclamation-triangle mr-2"></i> Error loading history: {error}
                </div>
            </div>
        );
    }

    if (!history || history.length === 0) {
        return (
            <div className="mb-8 transform-gpu hover:scale-[1.01] transition-medium">
                <h3 className="font-bold text-lg mb-5 flex items-center group">
                     {/* ... header ... */}
                     <div className="w-10 h-10 rounded-lg bg-accent-blue/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium"> <i className="fas fa-history text-accent-blue"></i> </div>
                    Bot Deployment History
                    <div className="ml-3 text-xs py-1 px-2 bg-accent-blue/20 rounded-full text-accent-blue opacity-0 group-hover:opacity-100 transition-medium">
                        Empty
                    </div>
                </h3>
                <div className="bg-dark-600 rounded-2xl p-6 hover:shadow-md transition-medium border border-dark-400 hover:border-accent-blue/30">
                    <p className="text-gray-400 text-center hover:text-white transition-medium">No deployment history available</p>
                </div>
            </div>
        );
    }

    return (
        <div className="mb-8 transform-gpu hover:scale-[1.01] transition-medium">
            <h3 className="font-bold text-lg mb-5 flex items-center group">
                 {/* ... header ... */}
                 <div className="w-10 h-10 rounded-lg bg-accent-blue/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium"> <i className="fas fa-history text-accent-blue"></i> </div>
                Bot Deployment History
                <div className="ml-3 text-xs py-1 px-2 bg-accent-blue/20 rounded-full text-accent-blue opacity-0 group-hover:opacity-100 transition-medium">
                    {history.length} records
                </div>
            </h3>

            <div className="bg-dark-600 rounded-2xl p-6 hover:shadow-md transition-medium border border-dark-400 hover:border-accent-blue/30">
                {/* ... rest of the table structure ... */}
                 <div className="border border-dark-400 rounded-xl overflow-hidden overflow-x-auto hover:border-dark-300 transition-medium">
                     <table className="w-full text-sm min-w-[600px]"> {/* Added min-width */}
                       <thead>
                         <tr className="bg-dark-500">
                           {['Date & Time', 'Server', 'Bot Type', 'Result', 'Actions'].map((header, index) => (
                             <th key={index} className="py-3 px-4 text-left font-medium text-gray-400 hover:text-white transition-medium"> {header} </th>
                           ))}
                         </tr>
                       </thead>
                       <tbody>
                         {history.map((item) => (
                           <tr key={item.id} className="border-t border-dark-400 hover:bg-dark-500 transition-medium">
                             <td className="py-3 px-4 hover:text-accent-blue transition-medium whitespace-nowrap">{item.date}</td>
                             <td className="py-3 px-4 hover:text-accent-blue transition-medium truncate max-w-[150px]">{item.server}</td> {/* Added truncate */}
                             <td className="py-3 px-4 hover:text-accent-blue transition-medium whitespace-nowrap">
                               <span className="flex items-center">
                                 {item.botType === 'op-bot' && <i className="fas fa-user-shield text-accent-purple mr-1 group-hover:rotate-12 transition-medium"></i>}
                                 {item.botType === 'crash-bot' && <i className="fas fa-bolt text-accent-orange mr-1 group-hover:rotate-12 transition-medium"></i>}
                                 {item.botType === 'account-bot' && <i className="fas fa-key text-accent-yellow mr-1 group-hover:rotate-12 transition-medium"></i>}
                                 {' '}
                                 {item.botType === 'op-bot' && 'OP Bot'}
                                 {item.botType === 'crash-bot' && 'Crash Bot'}
                                 {item.botType === 'account-bot' && 'Account Bot'}
                               </span>
                             </td>
                             <td className="py-3 px-4">
                               <span className={`px-2 py-1 ${item.resultColorClass || 'text-gray-400 bg-gray-500 bg-opacity-20'} rounded-lg text-xs hover:opacity-90 transition-medium`}>
                                 {item.result}
                               </span>
                             </td>
                             <td className="py-3 px-4">
                               <button className="px-2 py-1 bg-dark-400 hover:bg-dark-300 text-xs rounded-lg transition transform-gpu hover:-translate-y-0.5 hover:shadow-md active:translate-y-0 active:shadow-inner">
                                 View Log
                               </button>
                             </td>
                           </tr>
                         ))}
                       </tbody>
                     </table>
                 </div>
            </div>
        </div>
    );
};

export default BotDeploymentHistory;
